var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-kp",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M92.2 7.8h593.6v485.5H92.2z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "matrix(.86254 0 0 1.0546 -79.5 -8.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.1,
    d: "M991.8 492.9H4.2V8.4h987.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5698",
    d: "M991.8 405.2H4.2V493h987.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c60000",
    d: "M991.8 384.9H4.2V116.4h987.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5698",
    d: "M991.8 8.4H4.2V96h987.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M473 250.7c0 60.1-61.5 108.9-137.4 108.9-76 0-137.6-48.8-137.6-109 0-60.1 61.6-108.9 137.6-108.9S473 190.5 473 250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c40000",
    d: "m402.9 326.8-66.1-38.6-67.1 39 26.3-62.8-66.1-38.5 82.4-.3 26.2-63 24.5 62.8 82.4-.4-67.2 39z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKp);
export default __webpack_public_path__ + "static/media/kp.b18250781a066f1df14af3f01ea589ad.svg";
export { ForwardRef as ReactComponent };